import { useCallback } from "react";
import api from "../../../Component/axios";

export const useProgramacion = () => {
  const token = localStorage.getItem("@Token");

  const getProgramacion = useCallback(
    async (fecha, id_cultivo, asignado) => {
      let filter_asignado = ``;

      if (asignado || asignado >= 0) {
        filter_asignado = `&asignado=${asignado}`;
      }
      try {
        const response = await api.get(
          `api/programacion/empaque/?id_cultivo=${id_cultivo}&fecha=${fecha}${filter_asignado}`,
          {
            headers: {
              Authorization: "Token " + token,
            },
          }
        );
        return response.data;
      } catch (error) {
        console.error(error);
      }
    },
    [token]
  );

  const postProgramacion = async (data) => {
    try {
      await api.post(`api/programacion/empaque/`, data, {
        headers: {
          Authorization: "Token " + token,
        },
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const deleteProgramacion = async (id) => {
    try {
      await api.delete(`api/programacion/empaque/${id}`, {
        headers: {
          Authorization: "Token " + token,
        },
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const retriveProgramacion = useCallback(
    async (id) => {
      try {
        const response = await api.get(`api/programacion/empaque/${id}/`, {
          headers: {
            Authorization: "Token " + token,
          },
        });
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    [token]
  );

  const patchProgramacion = useCallback(
    async (id, data) => {
      try {
        const response = await api.patch(
          `api/programacion/empaque/${id}/`,
          data,
          {
            headers: {
              Authorization: "Token " + token,
            },
          }
        );
        return response.data;
      } catch (error) {
        console.error(error);
        throw error;
      }
    },
    [token]
  );

  const downloadProgramacion = async (id_cultivo, fecha) => {
    try {
      const response = await api.post(
        `api/programacion/download/`,
        { id_cultivo, fecha },
        {
          headers: {
            Authorization: "Token " + token,
          },
          responseType: "blob",
        }
      );
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  return {
    getProgramacion,
    postProgramacion,
    deleteProgramacion,
    retriveProgramacion,
    patchProgramacion,
    downloadProgramacion,
  };
};
